import { render, staticRenderFns } from "./EventReport.vue?vue&type=template&id=8a7ef066&scoped=true&"
import script from "./EventReport.vue?vue&type=script&lang=js&"
export * from "./EventReport.vue?vue&type=script&lang=js&"
import style0 from "./EventReport.vue?vue&type=style&index=0&id=8a7ef066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ef066",
  null
  
)

export default component.exports